<template>
  <div class="center-item-body">
    <div class="recharge-tab-body">
      <span class="recharge-tab" :class="rechargeType == 1 ? 'recharge-tab-active' : ''"
        @click="selectTab(1)">
        页游充值<i></i>
      </span>
      <span class="recharge-tab" :class="rechargeType == 2 ? 'recharge-tab-active' : ''"
        @click="selectTab(2)">
        手游充值<i></i>
      </span>
      <span class="recharge-tab" :class="rechargeType == 3 ? 'recharge-tab-active' : ''"
        @click="selectTab(3)">
        H5充值<i></i>
      </span>
      <span class="recharge-tab" :class="rechargeType == 4 ? 'recharge-tab-active' : ''"
        @click="selectTab(4)">
        平台币充值<i></i>
      </span>
    </div>
    <div class="recharge-order-body">
      <div class="recharge-order-header">
        <p>订单号</p>
        <p>游戏</p>
        <p>服务器</p>
        <p>充值金额</p>
        <p>支付方式</p>
        <p>交易时间</p>
        <p>交易状态</p>
      </div>
      <ul class="recharge-order-ul">
        <li class="recharge-order-li" v-for="(item,index) in rechargeList" :key="index">
          <p>{{item.recharge_order}}</p>
          <p>{{item.recharge_game_name}}</p>
          <p>{{item.recharge_game_area_name}}</p>
          <p>{{item.recharge_money}}元</p>
          <p>{{handleType(item.recharge_type)}}</p>
          <p>{{new Date(item.recharge_time).Format("yyyy-MM-dd")}}</p>
          <p>{{handleState(item.recharge_state)}}</p>
        </li>
      </ul>
      <CommonPage v-if="isPageShow" class="center-game-page" style="margin: 20px auto;" :current.sync='commonPage' :page-size="commonRow"
       :total="commonTotal" show-total  show-elevator  @on-change="selectPage"
       prev-text="上一页" next-text="下一页"/>
    </div>
    <div class="recharge-hint">
      <p>掉单说明:</p>
      <p class="mt-10">由于网络波动等原因，您的充值可能无法在游戏内到账，当交易 状态为掉单时，您的充值已转存为平台币，您可以使用平台币重新充值。</p>
      <p class="mt-10">如果遇到充值异常问题，请及时联系客服人员查询处理，谢谢！</p>
      <p class="mt-10">充值客服QQ:<span class="color-ff2801" @click="enterCustomer">13619030</span>（服务时间：9:00-18:00）</p>
    </div>
  </div>
</template>
 
<script>
  import CommonPage from '../../components/CommonPage';
  export default {
    data() {
      return {
        isPageShow:false,
        loginState:false,
        rechargeType:1, //支付类型 1:页游 2:手游 3:h5
        rechargeList:[],  
        commonTotal:0,
        commonPage:1,
        commonRow:12,
      };
    },
    components:{ CommonPage },
    mounted(){
      if (window.sessionStorage.getItem("token") !== null) {
        this.loginState = true;
      }    
      this.queryMineRecharge();
    },
    methods:{
      enterCustomer(){
        window.open("http://wpa.qq.com/msgrd?v=3&uin=13619030&site=qq&menu=yes","_blank");
      },
      selectPage(value){
        this.rechargeBean.page=value;
        this.queryMineRecharge();
      },
      selectTab(value){
        this.rechargeType = value;
        this.commonPage = 1;
        this.queryMineRecharge();
      },
      //处理支付类型
      handleType(value){
        switch(value){
          case 1:
            return "支付宝";
          case 2:
            return "微信";
          case 3:
            return "平台币";
          case 4:
            return "网银";
          default:
            return "支付宝";
        }
      },
      //处理订单状态
      handleState(value){
        switch(value){
          case 1:
            return "成功";
          case 2:
            return "失败";
          case 3:
            return "未知";
          default:
            return "未支付";
        }
      },
      queryMineRecharge(){
        this.$http.post('/query_web_mine_recharge?type='+this.rechargeType+"&page="+this.commonPage+"&row="+this.commonRow,
        {}).then(res =>{
          if (res.data.code ==2000) {
            this.rechargeList=res.data.data;
            this.commonTotal = res.data.total;
            if(this.commonTotal > this.commonRow){
              this.isPageShow = true;
            }else{
              this.isPageShow = false;
            }
          }else{
            this.rechargeList = [];
            this.isPageShow = false;
          }  
        })
      }, 
    },
    watch:{
      loginState(value){
        if(value){
          this.queryMineRecharge();
        }
      }
    }
  };
</script>
<style src="@/assets/css/mine_center.css" scoped></style>